<template>
  <v-row :no-gutters="simple">

    <v-col cols="12" style="position: relative;">
      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="error"
          @click="closeCreate"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="8">
              <div class="title pl-2">Personal Info</div>
              <v-row no-gutters>
                <v-col cols="12" sm="6" lg="4" class="pa-1">
                  <v-text-field
                    v-model="first_name"
                    label="First Name"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" class="pa-1">
                  <v-text-field
                    v-model="last_name"
                    label="Last Name"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                  />
                </v-col>
                <v-col cols="12" lg="4" class="pa-1">
                  <v-menu
                    ref="birthdayMenu"
                    v-model="birthdayMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="(birthday ? $moment(birthday).calendar() : '')"
                        label="Birthday"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        v-on="on"
                        clearable
                        placeholder=" "
                        @click:clear="birthday = null"
                        :disabled="saving"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="birthdayPicker"
                      v-model="birthday"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1900-01-01"
                      @change="saveBirthday"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" lg="12" class="pa-1">
                  <v-text-field
                    v-model="email"
                    label="Email"
                    outlined
                    placeholder=" "
                    :disabled="saving"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="4">
              <div class="title pl-2">Contact Info</div>
              <v-row no-gutters>
                <v-col class="py-1">
                  <v-card color="grey lighten-4">
                    <v-card-text>
                      <v-row no-gutters class="flex-column">
                        <v-col class="my-2">
                          <v-text-field
                            v-model="mobile_phone"
                            v-mask="phoneMask"
                            label="Mobile Phone"
                            placeholder=" "
                            prepend-inner-icon="mdi-cellphone"
                            outlined
                            hide-details
                            clearable
                            :disabled="saving"
                          />
                        </v-col>
                        <v-col class="my-2">
                          <v-text-field
                            v-model="home_phone"
                            v-mask="phoneMask"
                            label="Home Phone"
                            placeholder=" "
                            prepend-inner-icon="mdi-phone-classic"
                            outlined
                            hide-details
                            clearable
                            :disabled="saving"
                          />
                        </v-col>
                        <v-col class="my-2">
                          <v-text-field
                            v-model="work_phone"
                            v-mask="phoneMask"
                            label="Work Phone"
                            placeholder=" "
                            prepend-inner-icon="mdi-deskphone"
                            outlined
                            hide-details
                            clearable
                            :disabled="saving"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-btn color="primary" :disabled="!saveable" @click="submit" :loading="saving">Create</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { PHONE_MASK } from '@/global/consts.js';
import { processPhoneNumber } from '@/global/helpers.js';

export default {
  name: 'UsersCreate',
  props: {
    dialog: Boolean,
    simple: Boolean,
    type: {
      type: String,
      default: 'user'
    },
    user: {
      type: Object,
      required: true
    },
    householdId:[String, Number],
    agentId: [String, Number]
  },
  data: () => ({
    saving: false,
    birthdayMenu: false,
    spouseBirthdayMenu: false,
    customerOrAgent: 0,

    first_name: null,
    last_name: null,
    birthday: null,
    email: null,
    income_takehome: null,
    desiredOutcomes: null,
    desiredMonthlyCap: null,

    mobile_phone: null,
    home_phone: null,
    work_phone: null,
    spouse_mobile_phone: null,
    spouse_home_phone: null,
    spouse_work_phone: null,
    

    hasSpouse: false,
    spouse_first_name: null,
    spouse_last_name: null,
    spouse_birthday: null,
    spouse_email: null,
    spouse_income_takehome: null,

    phoneMask: PHONE_MASK,
  }),
  watch: {
    birthdayMenu (val) {
      val && setTimeout(() => (this.$refs.birthdayPicker.activePicker = 'YEAR'))
    },
    spouseBirthdayMenu (val) {
      val && setTimeout(() => (this.$refs.spouseBirthdayPicker.activePicker = 'YEAR'))
    },
  },
  computed: {
    saveable() {
      let spouseCheck = true
      if(this.hasSpouse) {
        if( !this.spouse_first_name ||
            !this.spouse_last_name ||
            !this.spouse_birthday ||
            !this.spouse_email
        ) spouseCheck = false
      }
      if( this.first_name &&
          this.last_name  &&
          this.birthday &&
          this.email &&
          spouseCheck
      ) return true
      return false
    }
  },
  methods: {
    async submit() {
      if(!this.saveable) return
      this.saving = true

      let data = {
        user_id: this.user.id,
        household_id: this.householdId,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        birthday: this.birthday,
        mobile_phone: processPhoneNumber(this.mobile_phone),
        mobile_phone_country: (this.mobile_phone ? 'US' : null),
        agent_id: (this.agentId || this.$root.currentUser.id),
        type: 'USER',
        setMeta: {
          home_phone: this.home_phone,
          work_phone: this.work_phone
        }
      }

      if(!this.simple) {
        var spouse = null
        if(this.hasSpouse) {
          try {
            spouse = await this.addSpouse()
          } catch {
            this.saving = false
            return
          }
        }

        data.household = {
          user_income_monthly:      this.income_takehome,
          desired_monthly_cap:      this.desiredMonthlyCap,
          desired_outcomes:         (this.desiredOutcomes ? this.desiredOutcomes.split("\n").join(",") : ''),
          spouse_id:                (spouse ? spouse : null),
          spouse_income_monthly:    (spouse ? this.spouse_income_takehome : null)
        }
      }

      this.$http.post('household-customer-data/create-household-user', data)

        .then(response => {
          if(response.data.id){
            this.$emit('new-spouse_id', {spouse: response.data})
          }

          if(this.dialog) {
            let cleanedIncome = ('' + this.income_takehome).replace(/[^0-9.]/g, '')
            this.$emit('on-user-added', {user: response.data, income: cleanedIncome})
            this.$emit('on-close')
          } else {
            this.$router.push({name: 'households-onboarding', params:{household_id: response.data.activeHousehold.id}})
          }
        })
        .catch(err => {
          console.log(err.response)
          let message = '<b>There was a problem saving the user</b>'
          if(err.response.status == 422) {
            for(let i = 0; i < err.response.data.length; i++) {
              message += '<br><span style="color: #f27474;">' + err.response.data[0].message + '</span>'
            }
          }
          this.$swal.fire('Error', message, 'error')
        })
        .finally(() => {
          this.saving = false
        })
    },
    addSpouse () {
      return new Promise((resolve, reject) => {
        if(!this.spouse_first_name || !this.spouse_last_name || !this.spouse_email || !this.spouse_birthday) reject(false)

        let data = {
          first_name: this.spouse_first_name,
          last_name: this.spouse_last_name,
          email: this.spouse_email,
          birthday: this.spouse_birthday,
          mobile_phone: this.spouse_mobile_phone,
          mobile_phone_country: (this.spouse_mobile_phone ? 'US' : null),
          agent_id: this.$root.currentUser.id,
          type: 'USER',
          setMeta: {
            home_phone: this.spouse_home_phone,
            work_phone: this.spouse_work_phone
          }
        }

        this.$http.post('users', data)
          .then(response => {
            resolve(response.data.id)
          })
          .catch(err => {
            console.log(err.response)
            this.$swal.fire('Error', 'There was a problem saving the spouse', 'error')
            reject()
          })
      })
    },
    saveBirthday(date) {
      this.$refs.birthdayMenu.save(date)
    },
    saveSpouseBirthday(date) {
      this.$refs.spouseBirthdayMenu.save(date)
    },
    formatDollar(field, e) {
      let value = e.srcElement.value
      value     = value.replace(/[^\d.]/g,'')
      if(value) {
        let formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        })
        value = formatter.format(value)
      } else {
        value = null
      }
      this[field] = value
    },
    makeDollarEditable(field, e) {
      let value = e.srcElement.value
      let cleaned = ('' + value).replace(/[^\d.]/g, '')
      this[field] = cleaned
    },
    closeCreate () {
      if(this.dialog) {
        this.$emit('on-close')
      } else {
        this.$router.push({name: 'clients'})
      }
    }
  }
}
</script>

<style lang="scss">
  .desiredOutcomesTextarea {
    textarea {
      resize: none;
      margin-top: 2px !important;
    }
  }
</style>